module.exports = __webpack_public_path__ + "img/button-cart-grey.86b68927.png";